// removed by extract-text-webpack-plugin
module.exports = {"root":"latest-clips__root","title":"latest-clips__title","clip":"latest-clips__clip","moreClips":"latest-clips__moreClips latest-clips__clip","moreClipsCard":"latest-clips__moreClipsCard","moreClipsLabel":"latest-clips__moreClipsLabel"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/show-page/components/latest-clips/styles.less
 ** module id = 439
 ** module chunks = 1
 **/